module.exports = __webpack_public_path__ + "img/host_logo_Landscape_green.d056c17a.png";